// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KJ63q","table":"styles_table__p4oEP","histDel":"styles_histDel__xxsiJ"};